/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentViewIntentQuery from './__generated__/VirtualAgentViewIntentQuery$parameters';
import type { VirtualAgentViewIntentQuery as VirtualAgentViewIntentQueryType } from './__generated__/VirtualAgentViewIntentQuery.graphql';

type ViewIntentEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentViewIntentQueryType;
	},
	{},
	{},
	{} | null
>;

export const viewIntentEntryPoint: EntryPoint<
	ViewIntentEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ViewIntentEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-view-intent" */ './VirtualAgentViewIntent.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: VirtualAgentViewIntentQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
					intentId: context.match.params.intentId ?? '',
				},
			},
		},
	}),
});
